<template>
  <div class="game-category">
    <div class="game-category-content mx-auto mb-1 mb-lg-3">
        <span v-if="isNew" class="category-new-icon">
          <img :src="newIcon" alt="">
        </span>
        <span class="category-inside">
          <svg v-if="icon.type === 'svg'" class="game-category-icon" v-html="icon.img"></svg>
          <img  v-else :src="icon.img" alt="VipMagnit онлайн Казино" class="game-category-icon">
        </span>
    </div>
    <p class="text-left text-lg-center my-auto m-lg-0 px-2 px-lg-0 category-title">
       <span class="game-category-name">{{ tabName }}</span>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'GameCategories',
    props: ['tabName', 'icon','isNew'],
    data() {
      return {
        newIcon: require('@/../public/images/icons/new-icon.png'),
      }
    },
    computed: {
      isMobile () {
        return this.$_config.environment.mobile
      }
    }
  }
</script>

<style>
  .category-new-icon{
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    display: block;
    height: 40px;
  }
  .category-new-icon>img{
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  }
  .game-category-content{
		display: flex;
		width: 100px;
		height: 100px;
		background-origin: border-box;
		background-clip: padding-box, border-box;
		position: relative;
		background-image: repeating-linear-gradient(45deg, rgba(7,10,17,1) 0%, rgba(7,10,17,1) 100%),  repeating-linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, #011e40 35%, #011e40 65%, rgba(255,255,255,0.6) 100%), linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, #011e40 35%, #011e40 65%, rgba(255,255,255,0.6) 100%);;
		border-style: solid;
		border-color:transparent;
		border-radius: 50%;
		border-width:1px;
		padding:3px;
  }
  .category-inside{
		display: flex;
		width: 96px;
		height: 92px;
		border: 1px solid transparent;
		border-radius: 50% !important;
		background-image: repeating-linear-gradient(45deg, rgba(7,10,17,1) 0%, rgba(7,10,17,1) 100%),  repeating-linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, #011e40 35%, #011e40 65%, rgba(255,255,255,0.6) 100%), linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, #011e40 35%, #011e40 65%, rgba(255,255,255,0.6) 100%);
		background-origin: border-box;
		background-clip: padding-box, border-box;
  }
  .game-category:hover .game-category-content{
		background-image: repeating-linear-gradient(45deg, rgba(7,10,17,1) 0%, rgba(7,10,17,1) 100%),  repeating-linear-gradient(to bottom, #e7041f 0%, #011e40 35%, #011e40 65%,#e7041f 100%), linear-gradient(to bottom, #e7041f 0%, #011e40 35%, #011e40 65%,#e7041f 100%);
  }
  .game-category:hover .category-inside{
		background-image: repeating-linear-gradient(45deg, #0a1123 0%,#0a1123 100%),  repeating-linear-gradient(to bottom, #e7041f 0%, #011e40 35%, #011e40 65%,#e7041f 100%), linear-gradient(to bottom, #e7041f 0%, #011e40 35%, #011e40 65%,#e7041f 100%);
		box-shadow: 0 0 0 3px inset #070a11;
  }
  .games-category.active .category-inside{
    background-image: repeating-linear-gradient(45deg, #0a1123 0%,#0a1123 100%),  repeating-linear-gradient(to bottom, #e7041f 0%, #011e40 35%, #011e40 65%,#e7041f 100%), linear-gradient(to bottom, #e7041f 0%, #011e40 35%, #011e40 65%,#e7041f 100%);
    box-shadow: 0 0 0 3px inset #070a11;
  }
  .games-category.active .game-category-content{
    background-image: repeating-linear-gradient(45deg, rgba(7,10,17,1) 0%, rgba(7,10,17,1) 100%),  repeating-linear-gradient(to bottom, #e7041f 0%, #011e40 35%, #011e40 65%,#e7041f 100%), linear-gradient(to bottom, #e7041f 0%, #011e40 35%, #011e40 65%,#e7041f 100%);
  }
  .games-category.active .game-category-name,
  .game-category:hover .game-category-name{
		color: #e7041f !important;
  }
  .game-category:hover .game-category-icon{
    transform: scale(1.2);
    transition: 0.6s;
  }
  .game-category{
    height: 100%;
    color: #ffffff;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
  }
  .game-category-icon{
    width: 35px;
    height: 35px;
    display: block;
    margin: auto;
    object-fit: contain;
    transition: 0.6s;
  }
  .game-category-icon:hover path,
  .game-category-icon:hover g,
  .game-category-icon:hover circle,
  .category-title:hover .game-category-icon path,
  .category-title:hover .game-category-icon g,
  .category-title:hover .game-category-icon circle,
  .games-category.active .game-category-icon path,
  .games-category.active .game-category-icon g,
  .games-category.active .game-category-icon circle
  {
    fill: #ffffff;
    stroke: #ffffff;
  }

  .game-category-icon:hover path.no-stroke,
  .game-category-icon:hover g.no-stroke,
  .game-category-icon:hover circle.no-stroke,
  .category-title:hover .game-category-icon path.no-stroke,
  .category-title:hover .game-category-icon g.no-stroke,
  .category-title:hover .game-category-icon circle.no-stroke,
  .games-category.active .game-category-icon path.no-stroke,
  .games-category.active .game-category-icon g.no-stroke,
  .games-category.active .game-category-icon circle.no-stroke
  {
    stroke: none !important;
  }
  @media screen and (max-width: 992px){
    .category-new-icon{
      top: -20px;
      left: 100px;
    }
  }
</style>
<style scoped>

</style>
